import { IconButton, useTheme } from '@mui/material';
import { DisclosureIcon } from '@wavetrak/theme';
import React from 'react';

interface Props {
  ariaControls?: string;
  ariaExpanded?: boolean;
  ariaLabel?: string;
  color?: string;
  dataTestId?: string;
  disabled?: boolean;
  onClick?: () => void;
  rotation: number;
  size?: number;
}

const Disclosure: React.FC<Props> = ({
  ariaControls,
  ariaExpanded,
  ariaLabel = '',
  color,
  dataTestId = '',
  disabled = false,
  onClick = () => {},
  rotation,
  size = 11,
}) => {
  const theme = useTheme();
  const iconColor = color ?? theme.palette.text.brandSecondary;
  return (
    <IconButton
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      color="secondary"
      onClick={onClick}
      disabled={disabled}
      disableFocusRipple
      disableRipple
      disableTouchRipple
    >
      <DisclosureIcon rotation={rotation} size={size} color={iconColor} />
    </IconButton>
  );
};

export default Disclosure;
